import React from 'react';
import { useIntl } from 'react-intl';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Box, Typography, Button, Container, TypographyProps } from '@mui/material';
import { styled } from '@mui/material/styles';
import useScrollToTop from '../../hooks/useScrollToTop';

const StyledTypography = styled(Typography)<TypographyProps>(({ theme }) => ({
  fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
}));

const StyledImage = styled('img')(({ theme }) => ({
  width: '100%',
  maxWidth: '300px',
  height: 'auto',
  borderRadius: '8px',
  objectFit: 'cover',
}));

const BrianMcGrane: React.FC = () => {
  const intl = useIntl();
  const t = (id: string) => intl.formatMessage({ id });
  useScrollToTop();

  return (
    <Box sx={{ 
      minHeight: '100vh', 
      bgcolor: 'grey.50',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center'
    }}>
      {/* Hero Section */}
      <Box sx={{ 
        bgcolor: 'white',
        width: '100%',
        display: 'flex',
        justifyContent: 'center'
      }}>
        <Container maxWidth="lg" sx={{ py: 8, px: { xs: 4, sm: 6, lg: 8 } }}>
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            <Box sx={{ textAlign: 'center' }}>
              <StyledTypography variant="h2" component="h1" gutterBottom>
                {t('team.brianMcGrane.name')}
              </StyledTypography>
              <StyledTypography variant="h5" color="text.secondary" sx={{ mt: 3 }}>
                {t('team.brianMcGrane.title')}
              </StyledTypography>
            </Box>
          </motion.div>
        </Container>
      </Box>

      {/* Bio Section */}
      <Container maxWidth="lg" sx={{ py: 8, px: { xs: 4, sm: 6, lg: 8 } }}>
        <motion.div
          initial={{ opacity: 0, x: -20 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
        >
          <Box sx={{ 
            display: 'grid',
            gridTemplateColumns: { xs: '1fr', md: '1fr 2fr' },
            gap: 4,
            alignItems: 'start'
          }}>
            <Box>
              <StyledImage 
                src="/images/爱尔兰律师照片.png" 
                alt={t('team.brianMcGrane.name')}
              />
            </Box>
            <Box>
              <StyledTypography variant="body1" color="text.secondary" paragraph>
                {t('team.brianMcGrane.bio.paragraph1')}
              </StyledTypography>
              <StyledTypography variant="body1" color="text.secondary" paragraph>
                {t('team.brianMcGrane.bio.paragraph2')}
              </StyledTypography>
              <Box sx={{ mt: 4, display: 'flex', justifyContent: 'flex-end' }}>
                <Button
                  component={Link}
                  to="/about"
                  variant="contained"
                  color="primary"
                >
                  {t('team.brianMcGrane.backButton')}
                </Button>
              </Box>
            </Box>
          </Box>
        </motion.div>
      </Container>
    </Box>
  );
};

export default BrianMcGrane; 